<template>
  <div class="f-ast f-v">
    <div class="t t-xl ta-c m-tx3 m-bx3">
      Download the <span class="bold">{{ listingName }}</span> below, and then you're all set!
      <br>
      <br>
      You'll find step-by-step Slack emoji installation instructions in the downloaded zip file.
    </div>
    <donut-modal-sections-actions
      cancel-text="Close"
      button-text="Download"
      save-mutation="updateExistingModal"
      :save-args="{}"
      :save-function="downloadZip"
    >
      <template #saveButton="{ buttonText }">
        <span>{{ buttonText }}</span>
        <i class="mi m-lx1">file_download</i>
      </template>
    </donut-modal-sections-actions>
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { state } = useStore();

  const listingName = computed(() => state.modal.data?.listing?.name);

  const zipUrl = `${process.env.CDN_HOSTNAME || process.env.S3_HOSTNAME}/static/donut_emoji_kit.zip`;

  const downloadZip = () => {
    const link = document.createElement('a');

    link.href = zipUrl;
    link.download = 'donut-emoji-kit.zip';
    link.rel = 'noopener noreferrer';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
</script>
